module.exports = __webpack_public_path__ + "static/img/news_pic.7bc5b90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/news_pic.png
// module id = IXRU
// module chunks = 44